import React, { useEffect, useCallback } from 'react';
import { Route } from 'react-router-dom';
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from 'react-redux'
import * as familiasActions from '../../store/familias/familias.actions';
import FamilyNav from './../../components/FamiliaNav/FamiliaNav';
import Error from './../../components/Error/Error';
import ProductList from './../../components/ProductList/ProductList';
import Spinner from './../../core/Spinner/Spinner';
import Search from '../../components/Search/Search';
import './Products.scss';

const Products: React.FunctionComponent<any> = ({ match }) => {
    const { error, familias, fetching } = useSelector((state: any) => state.familiasStore);
    const dispatch = useDispatch();

    const fetchData = useCallback(() => {
        if (!familias.length) dispatch(familiasActions.requestFamilias());
    }, [dispatch, familias.length]);

    useEffect(() => fetchData(), [fetchData]);

    if (error) {
        return (
            <div className="ProductsError"><Error retry={fetchData}  /></div>
        );
    }

    if (fetching) {
        return (
            <div className="container ProductsContainer">
                <Spinner>Buscando productos y categorías...</Spinner>
            </div>
        );
    }

    return (
        <div className="container">
            <Helmet>
                <title>Héctor Blejer | Productos</title>
                <meta name="description" content="Hector Blejer. Representaciones comerciales" />
                <meta name="keywords" content="Hector Blejer, hector, blejer, fabrica, fabricas, distribuidor, insumos, limpieza, representaciones comerciales, comercial, representacion, productos, negocios" />
            </Helmet>
            <div className="container ProductsContainer">
                <div className="ProductFilterContainer">
                    <Search />
                </div>
                <div className="FamiliasContainer">
                    <div className="FamiliaList">
                        <FamilyNav familias={familias} match={match} />
                    </div>
                </div>
                <div className="ProductListContainer">
                    <Route path={`${match.path}/`} component={ProductList}/>
                </div>
            </div>
        </div>
    );
};

export default Products;